import React, { useEffect } from 'react';
import Button from 'reactstrap/lib/Button';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../../../Components/Components/Modal';
import { isMobileDevice } from '../../../../../../../utils/deviceUtils';
import { setUserScreenViewNew } from '../../../../../../../actions/member';
import { connect } from 'react-redux';
import { getTabLabelById, MENU_NAVIGATION, SCREENS } from '../../../../../../../constants/constants';

const RatingsInfo = React.memo(({ toggleRatingsInfo, toggleRatingsModal, setScreenViewNew }) => {
  const { t } = useTranslation('common');

  useEffect(() => {
    if (toggleRatingsInfo) {
      setScreenViewNew(SCREENS.MY_INFO.RATING_INFO);
    }
  }, [toggleRatingsInfo]);

  return (
    <CustomModal
      isOpen={toggleRatingsInfo}
      toggle={toggleRatingsModal}
      size="md"
      title={t('myInfo.ratingsInfo')}
      addClassName={(isMobileDevice()) && `my-info-ratings-modal-mobile-wrapper`}
      disableFlex
      body={(
        <div className="my-info-ratings-description">
          <div className="mb-2">{t('myInfo.ratingsInfo1')}</div>
          <div className="mb-2">{t('myInfo.ratingsInfo2')}</div>
          <div className="mb-2" >{t('myInfo.ratingsInfo3')}</div>
        </div>
      )}
      footer={(
        <Button color="secondary" onClick={toggleRatingsModal}>
          {t('common.close')}
        </Button>
      )}
    />
  );
});

const mapDispatchToProps = {
  setScreenViewNew: setUserScreenViewNew,
};

export default connect(null, mapDispatchToProps)(RatingsInfo);
